import { z } from "zod";

export const loginFormSchema = z.object({
  email: z
    .string()
    .min(1, {
      message: "This field has to be filled.",
    })
    .email("This is not a valid email")
    .max(300, {
      message: "Email can't be longer than 300 characters.",
    }),
});

export const registerFormSchema = z.object({
  email: z
    .string()
    .min(1, {
      message: "This field has to be filled.",
    })
    .email("This is not a valid email")
    .max(300, {
      message: "Email can't be longer than 300 characters.",
    }),
  firstName: z
    .string()
    .min(1, {
      message: "This field has to be filled.",
    })
    .max(128, {
      message: "First name can't be longer than 128 characters.",
    }),
  lastName: z
    .string()
    .min(1, {
      message: "This field has to be filled.",
    })
    .max(128, {
      message: "Last name can't be longer than 128 characters.",
    }),
  newsletter: z.boolean(),
})